import {useEffect, useState} from 'react'

/** Rendering above 2x is not worth the memory on a document page. */
export const MAX_PDF_DPR = 2

export function getPdfDpr(): number {
  if (typeof window === 'undefined') return 1
  return Math.min(window.devicePixelRatio || 1, MAX_PDF_DPR)
}

/**
 * True on devices with a real pointer, where hover affordances (carousel
 * arrows, page hints) make sense. Touch devices always show the controls.
 */
export function useHasHover(): boolean {
  const [hasHover, setHasHover] = useState(true)

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return
    const query = window.matchMedia('(hover: hover) and (pointer: fine)')
    setHasHover(query.matches)
    const listener = (event: MediaQueryListEvent) => setHasHover(event.matches)
    query.addEventListener('change', listener)
    return () => query.removeEventListener('change', listener)
  }, [])

  return hasHover
}
